import { useQuery } from "@tanstack/react-query";
import type { AdminGovernorateView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useAreaGovernoratesQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.areaGovernorates(),
    queryFn: () =>
      apiJsonClient<AdminGovernorateView[]>(endpoints.admin.areaGovernorates),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
